<template>
  <div>
    <h3>Overload Requests</h3>

    <b-alert show>
      Review overload interest.
    </b-alert>

    <b-form inline @submit.prevent="" class="mb-2">
      <b-input-group class="filter-group">
        <b-input-group-prepend is-text>
          <font-awesome-icon icon="search" />
        </b-input-group-prepend>
        <b-form-input v-model="filter" placeholder="Type to Search" debounce="500"></b-form-input>
        <b-input-group-append>
          <b-button @click="filter = null">Clear</b-button>
        </b-input-group-append>
      </b-input-group>

      <b-input-group class="filter-group">
        <b-form-select
          v-model="selectedTermId"
          :options="terms"
          value-field="termId"
          text-field="description"
        >
          <template slot="first">
            <!-- this slot appears above the options from 'options' prop -->
            <option :value="null">All Semesters</option>
          </template>
        </b-form-select>
      </b-input-group>

    </b-form>

    <b-table striped
             hover
             :items="filteredItems"
             :fields="fields"
             :per-page="perPage"
             :current-page="currentPage"
             sort-by="name"
             responsive
             show-empty>
      <template v-slot:cell(workload.timePeriod.description)="data">
        {{ data.item.workload.timePeriod.description }}
      </template>
      <template v-slot:cell(employee.fullName)="data">
        {{ data.item.employee.fullName }} 
      </template>
      <template v-slot:cell(buyoutPercent)="data">
        {{ data.item.buyoutPercent }}%
      </template>
      <template v-slot:cell(createdDate)="data">
        {{ data.item.createdDate | formatDateTime }}
      </template>
    </b-table>

    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />
  </div>
</template>

<script>
import overageRequestsApi from "../../api/overageRequests";
import termsApi from "../../api/terms";
import roleChecks from "../../misc/role-checks";

export default {
  mixins: [roleChecks],

  data() {
    return {
      filter: "",
      currentPage: 1,
      perPage: 20,
      fields: [
        {
          key: "workload.timePeriod.description",
          sortable: true,
          label: "Year",
        },
        { key: "term.description", label: "Semester", sortable: true },
        { key: "employee.fullName", sortable: true, label: "Faculty" },
        { key: "createdDate", sortable: true, label: "Date Submitted" },
      ],
      requests: [],
      //terms: [],
      selectedTermId: null,
    };
  },

  computed: {
    terms: function() {
      var mappedTerms = _.map(this.requests, (request) => {
        return {
          termId: request.term.termId,
          termCode: request.term.termCode,
          description: request.term.description,
        };
      });

      var uniqueTerms = _.uniqBy(mappedTerms, (term) => term.termId);
      return _.sortBy(uniqueTerms, (term) => term.termCode);
    },

    filteredItems: function() {
      var filtered = this.requests;

      if (this.selectedTermId) {
        filtered = this.matchTerm(filtered, this.selectedTermId);
      }

      filtered = this.search(filtered, this.filter);

      return filtered;
    },

    totalRows: function() {
      return this.filteredItems.length || 0;
    },
  },

  methods: {
    matchTerm(collection, termId) {
      if (termId != null) {
        return _.filter(collection, function(object) {
          if (object.termId) {
            return object.termId === termId;
          }
          return false;
        });
      } else {
        return collection;
      }
    },

    search(collection, text) {
      var that = this;
      return _.filter(collection, function(object) {
        var search = that.deepSearch(object, text.toLowerCase());
        return _.keys(search).length > 0;
      });
    },

    deepSearch(collection, predicate, thisArg) {
      if (_.isFunction(predicate)) {
        predicate = _.iteratee(predicate, thisArg);
      } else {
        var keys = _.flatten(_.tail(arguments));
        if (typeof keys === "string") {
          keys = keys.toLowerCase();
        }
        predicate = function(val) {
          if (typeof val === "string") {
            val = val.toLowerCase();
          }
          return _.includes(val, keys);
        };
      }
      var that = this;
      return _.transform(collection, function(memo, val, key) {
        var include = predicate(val, key);
        if (!include && _.isObject(val)) {
          val = that.deepSearch(val, predicate);
          include = !_.isEmpty(val);
        }
        if (include) {
          _.isArray(collection) ? memo.push(val) : (memo[key] = val);
        }
      });
    },
  },

  created() {
    overageRequestsApi
      .getRequests()
      .then((response) => {
        this.requests = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });

    // termsApi.getTermsActive().then((response) => {
    //   this.terms = response.data;
    // });
  },
};
</script>

<style scoped>
.filter-group {
  margin: 10px 1em 15px 0;
  max-width: 600px;
}
</style>
